export function logExtractedData(viewData, isUpdate) {
  const {
    documentId,
    user,
    actualCountDate,
    editedItems,
    infiniteItems,
    existingEditedRawMaterials,
  } = viewData;

  console.log("Operation:", isUpdate ? "UPDATE" : "CREATE");
  console.log("Document ID:", documentId);
  console.log("Adjusted By:", user);
  console.log("Actual Count Date:", actualCountDate);
  console.log("Edited:", editedItems);
  console.log("Raw Materials:", infiniteItems);
  console.log("Existing Edited Raw Materials:", existingEditedRawMaterials);
}

export function generateAuditMessage(
  editedItems,
  existingEditedRawMaterials,
  isUpdate,
) {
  const editedItemsArray = Object.values(editedItems);

  if (isUpdate) {
    const changedItems = editedItemsArray
      .map((item) => {
        const oldQty =
          existingEditedRawMaterials[item.id]?.quantity ||
          item.stock_quantity ||
          "0";
        const newQty = item.quantity || "0";
        return `${item.itemName}: ${oldQty} → ${newQty}`;
      })
      .join(", ");

    return `Actual Count Updated: ${changedItems}`;
  }

  const itemCount = editedItemsArray.length;
  const itemNames = editedItemsArray
    .slice(0, 3)
    .map((i) => i.itemName)
    .join(", ");

  return `Actual Count Created: ${itemCount} item(s) adjusted${
    itemCount > 3 ? ` (${itemNames}...)` : ` (${itemNames})`
  }`;
}

export function createBusinessDayRange(actualCountDate) {
  const selectedDate = new Date(actualCountDate);

  const startOfBusinessDay = new Date(selectedDate);
  startOfBusinessDay.setHours(5, 0, 0, 0);

  const endOfBusinessDay = new Date(selectedDate);
  endOfBusinessDay.setDate(endOfBusinessDay.getDate() + 1);
  endOfBusinessDay.setHours(4, 59, 59, 999);

  return {
    start: startOfBusinessDay.toISOString(),
    end: endOfBusinessDay.toISOString(),
  };
}

export function toNumber(v) {
  const n = Number.parseFloat(String(v ?? "0"));
  return Number.isFinite(n) ? n : 0;
}

export function getBusinessDate(now) {
  const d = new Date(now);
  if (d.getHours() < 5) d.setDate(d.getDate() - 1);
  return d.toISOString().substring(0, 10);
}

export function addDaysISO(isoOrDateString, days) {
  const day = toISODate(isoOrDateString); // normalize first
  const d = new Date(day + "T00:00:00.000Z");
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function addDays(dateObj, days) {
  const d = new Date(dateObj);
  d.setDate(d.getDate() + days);
  return d;
}

export function toISODate(value) {
  const d = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(d.getTime())) {
    throw new Error(`Invalid date input: ${String(value)}`);
  }

  return d.toISOString().slice(0, 10);
}

export function isAfterFiveAMManila(date = new Date()) {
  const manilaNow = new Date(
    new Intl.DateTimeFormat("en-US", {
      timeZone: "Asia/Manila",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date),
  );

  // Build 05:00:00 AM "today" in Manila
  const y = manilaNow.getFullYear();
  const m = manilaNow.getMonth();
  const d = manilaNow.getDate();
  const fiveAM = new Date(y, m, d, 5, 0, 0); // local to constructed manilaNow

  return manilaNow.getTime() >= fiveAM.getTime();
}

export function getCurrentDateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}
